import React, { useContext } from 'react';
import { PageTitle } from 'src/components/Layout/PageTitle';
import { SummaryInfo } from 'src/components/Basket/SummaryInfo';
import { CouponProvider } from 'src/components/Basket/BasketActions';
import { Spinner, StaticSpinner } from 'src/components/Layout/Spinner';
import { BasketModalConnected } from 'src/components/Basket/BasketModal';
import { Cards } from 'src/components/Common/Cards';
import { AppMessageConnected } from 'src/components/AppShell/AppMessage';
import { BasketCspContext, BasketCspContextProvider } from 'src/components/Basket/BasketCspContext';
import { useLazyRegister } from 'src/core/engine/hooks/useRegisterFeature';
import { customisationRegister } from 'src/components/CustomisationPage/feature/customisation.register';
import { BasketActions } from 'src/components/Basket/BasketActions';

import { Container, TwoCol } from '../../Layout';
import { BasketItems } from '../BasketItems';
import { BasketSummary } from '../BasketSummary';
import { BasketContext, BasketContextProvider } from '../BasketContext';

export const BasketPage = React.memo(() => {
    const { basketItems, itemsPending, isPending, setupCost, setupCostAfterDiscount, setupCostDiscount } =
        useContext(BasketContext);
    const { userKind } = useContext(BasketCspContext);

    const ready = useLazyRegister(customisationRegister, true, 'Customisation');

    if (!ready) return null;

    return (
        <Container>
            <AppMessageConnected />
            <PageTitle title="My Basket">{isPending || (itemsPending.length > 0 && <StaticSpinner />)}</PageTitle>

            {basketItems.length === 0 && !isPending && <p>You currently have no items in your basket</p>}
            {basketItems.length === 0 && isPending && <Spinner />}

            {basketItems.length > 0 && (
                <TwoCol
                    main={
                        <>
                            <BasketItems
                                items={basketItems}
                                isPending={isPending}
                                itemsPending={itemsPending}
                                userKind={userKind}
                                setupCost={setupCost}
                                setupCostAfterDiscount={setupCostAfterDiscount}
                                setupCostDiscount={setupCostDiscount}
                            />
                            <BasketActions />
                            {/* {treatment === 'on' && <BasketUpsell />} */}
                        </>
                    }
                    right={
                        <>
                            <BasketSummary isPending={isPending} />
                            <SummaryInfo />
                            <Cards showPaypal />
                        </>
                    }
                />
            )}
            <BasketModalConnected />
        </Container>
    );
});

export const BasketPageConnected: React.FC = () => {
    return (
        <BasketContextProvider>
            <BasketCspContextProvider>
                <CouponProvider>
                    <BasketPage />
                </CouponProvider>
            </BasketCspContextProvider>
        </BasketContextProvider>
    );
};
